var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":"/balance"}},[_c('div',{staticClass:"header-custom"},[_c('div',[_vm._v("账号余额："+_vm._s(this.formatPrice(_vm.allBalance)))]),_c('div',[_c('van-icon',{attrs:{"name":"arrow"}})],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }